import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { auctionRegistrationTracking } from "../api/ApiRoutesFile";

export const refundApiSlice = createApi({
  reducerPath: "refundApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://castle-auction-production.up.railway.app/api/",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      const token = localStorage.getItem("auction_portal");
      if (token) {
        headers.set("x-auth-token", token);
      }
      return headers;
    },  
  }),
  tagTypes: ["Refunds"],
  endpoints: (builder) => ({
    refunds: builder.query({
      query: ({ endpoint, id, params }) => {
        const url = `${endpoint}${id}`;
        return {
          url,
          method: "GET",
          params: params || undefined,
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.applications.map(({ _id }) => ({
                type: "Refunds",
                id: _id,
              })),
              { type: "Refunds", id: "LIST" },
            ]
          : [{ type: "Refunds", id: "LIST" }],
    }),

    updateRefund: builder.mutation({
      query: ({ endpoint, id, formData }) => ({
        url: `${endpoint}`,
        method: "PUT",
        body: formData,
      }),
      // Wait for API response before updating the cache
      async onQueryStarted(
        { endpoint, id, formData, params, lastId },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data } = await queryFulfilled; // wait for the API call to complete
          if (data && data.application) {
            // Update paginated cache if applicable
            dispatch(
              refundApiSlice.util.updateQueryData(
                "refunds",
                { endpoint: auctionRegistrationTracking, id: lastId, params },
                (draft) => {
                  const index = draft.applications.findIndex(
                    (a) => a._id === id
                  );
                  if (index !== -1) {
                    draft.applications[index] = data.application;
                  }
                }
              )
            );
          }
        } catch (error) {
          console.error("Update failed:", error);
          // Handle rollback if needed
        }
      },
    }),
  }),
});

export const { useRefundsQuery, useUpdateRefundMutation } = refundApiSlice;
